import { useLang } from "../contexts/LanguageContext";
import {
  Sparkles,
  Trophy,
  Medal,
  Star,
  Flame,
  Clock3,
  CalendarCheck,
  GraduationCap,
  Lock,
} from "lucide-react";

// All possible badges with their icons and colors
export const BADGE_META = {
  first_month: { icon: Star, color: "#A762B1" },
  three_months: { icon: Medal, color: "#E59D32" }, // gold
  six_months: { icon: Trophy, color: "#E59D32" }, // gold
  one_year: { icon: Sparkles, color: "#A762B1" }, // mauve
  streak_3: { icon: Flame, color: "#DC2626" },
  temporal_1_month: { icon: Clock3, color: "#101A42" },
  temporal_6_months: { icon: Clock3, color: "#E59D32" }, // gold
  temporal_1_year: { icon: Clock3, color: "#A762B1" }, // mauve
  tutorial_done: { icon: GraduationCap, color: "#A762B1" },
  expert_en_herbe: { icon: Trophy, color: "#E59D32" }, // gold
};

const ALL_BADGE_KEYS = [
  "tutorial_done",
  "first_month",
  "three_months",
  "streak_3",
  "six_months",
  "one_year",
  "expert_en_herbe",
  "temporal_1_month",
  "temporal_6_months",
  "temporal_1_year",
];

export default function BadgesGrid({ earned = [] }) {
  const { t } = useLang();
  const earnedSet = new Set(earned);

  return (
    <div
      className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3"
      data-testid="badges-grid"
    >
      {ALL_BADGE_KEYS.map((key) => {
        const meta = BADGE_META[key] || { icon: CalendarCheck, color: "#101A42" };
        const Icon = meta.icon;
        const isEarned = earnedSet.has(key);
        return (
          <div
            key={key}
            data-testid={`badge-${key}${isEarned ? "-earned" : "-locked"}`}
            className={`rounded-2xl border-2 p-5 transition-transform ${
              isEarned
                ? "border-transparent bg-white shadow-[0_8px_30px_rgba(30,63,51,0.08)]"
                : "border-dashed border-[#101A42]/20 bg-[#FFF7E9]/60"
            }`}
            style={isEarned ? { borderColor: meta.color + "55" } : undefined}
          >
            <div
              className="flex h-14 w-14 items-center justify-center rounded-2xl"
              style={{
                backgroundColor: isEarned ? meta.color + "22" : "#E8DFC7",
                color: isEarned ? meta.color : "#9CA3AF",
              }}
            >
              {isEarned ? (
                <Icon className="h-7 w-7" strokeWidth={2} />
              ) : (
                <Lock className="h-6 w-6" strokeWidth={2} />
              )}
            </div>
            <p
              className={`mt-3 font-serif text-lg font-semibold ${
                isEarned ? "text-[#101A42]" : "text-[#4A4A4A]"
              }`}
            >
              {t(`badge_${key}`)}
            </p>
            <p
              className={`mt-1 text-sm leading-relaxed ${
                isEarned ? "text-[#4A4A4A]" : "text-[#8A8A8A]"
              }`}
            >
              {isEarned ? t(`badge_${key}_desc`) : t("badge_locked")}
            </p>
          </div>
        );
      })}
    </div>
  );
}
